import americanBankerLogo from "./americanbanker.svg";
import crunchbaseLogo from "./crunchbase.svg";
import forbesLogo from "./forbes.svg";
import nerdWalletLogo from "./nerdwallet.svg";
import techCrunchLogo from "./techcrunch.svg";

import styles from "./styles.module.scss";

function Publishers() {
  return (
    <section className={styles["publishers-section"]}>
      <span className={styles["as-seen-in"]}>
        As seen in<sup>1</sup>
      </span>
      <div className={styles["logo-wrapper"]}>
        <img
          alt="Nerdwallet logo"
          className={styles["publisher-logo"]}
          src={nerdWalletLogo.src}
        />
        <img
          alt="Forbes logo"
          className={styles["publisher-logo"]}
          src={forbesLogo.src}
        />
        <img
          alt="TechCrunch logo"
          className={styles["publisher-logo"]}
          src={techCrunchLogo.src}
        />
        <img
          alt="American Banker logo"
          className={styles["publisher-logo"]}
          src={americanBankerLogo.src}
        />
        <img
          alt="Crunchbase logo"
          className={styles["publisher-logo"]}
          src={crunchbaseLogo.src}
        />
      </div>
    </section>
  );
}

export default Publishers;
